<mojo-reports-job-item-common
  [jobItem]="jobItem"
  [aggregatedJobData]="aggregatedJobData"
>
  <mojo-dashboard-avg-response-time
    middle
    [avgResponseTime]="avgResponseTime"
  >
  </mojo-dashboard-avg-response-time>
  <mojo-dashboard-total-matches-numbers
    right
    *ngIf="aggregatedJobData"
    [aggregatedJobData]="aggregatedJobData"
  >
  </mojo-dashboard-total-matches-numbers>
</mojo-reports-job-item-common>
